<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('providers')"
        icon="network-wired"
        color="bg-pastel-purple"
      />
    </l-container>

    <hot-table :data="providers" :settings="settings" ref="hot" :key="componentKey">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column :title= "this.$t('name')" data="name" read-only="true"></hot-column>
      <hot-column :title= "this.$t('acronym')" data="acronym" read-only="true"></hot-column>
      <hot-column :title= "this.$t('description')" data="description" read-only="false"></hot-column>
      <hot-column title="Atom" data="atom" read-only="false"></hot-column>
      <hot-column :title= "this.$t('providerregistered')" :renderer="dateRenderer" data="created" read-only="true"></hot-column>
    </hot-table>
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import ProvidersService from "../../../helpers/apiservices/providers/providers.service";

import Notify from "@/helpers/notify";

export default {
  name: "providers",
  components: {
    HotTable,
    HotColumn,
    //LInput,
    //LButton,
    //LInfoBox,
  },
  data() {
    return {
      providers: [],
      settings: HandsontableHelper.settings(false),
      dateRenderer: HandsontableHelper.dateRenderer,
      componentKey: 0
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);

    //forcing recreation of hot-table since nor re-rendering of table or edit settings updated headers
    this.$root.$on('rendertable', () => {
      this.componentKey += 1;
    }); 
  },

  methods: {
    async loadInitialData() {
      this.providers = await ProvidersService.providers();
    }
  }
};
</script>



